import axios from "axios";
import { endpoint } from "../../config";
import { customToast } from "../../lib/toastLib";

const getNavigationLink = (progress_url, iframe_url, applicationId) => {
  if (!progress_url) {
    return "";
  } else if (iframe_url) {
    return `${progress_url}?url=${encodeURIComponent(`${iframe_url}&applicationId=${applicationId}`)}`;
  } else {
    return `${progress_url}?applicationId=${applicationId}`;
  }
};

const CcOfferStatusApi = async (app_id) => {
  try {
    const apiLink = `${endpoint}/api/offer-screen-cc/${app_id}`;
    const response = await axios.get(apiLink);
    const data = response.data;

    const dataArray = [];
    const unmatched = [];
    if (data) {
      data.data.forEach((obj) => {
        console.log("offer-screen-lap",obj);
        const statusObj = {
          lender: obj.lender || "N.A.",
          status: obj.status || "N.A.",
          amount: obj.amount || "N.A.",
          navigationLink: getNavigationLink(obj.in_progress_url, obj.Iframe_url, obj.applicationId),
          application_id: obj.applicationId || null
        };
        dataArray.push(statusObj);
      });
    }

    if(data.unmatched) {
      unmatched.push(...data.unmatched);
    }

    return {data: dataArray, unmatched};
  } catch (error) {
    if (error.response) {
      customToast.error(error.response.data?.message);
    } else {
      customToast.error(error.message);
    }
    throw error;
  }
};

export default CcOfferStatusApi;
